import { render, staticRenderFns } from "./UploadedImage.vue?vue&type=template&id=e8d98d94&scoped=true&"
import script from "./UploadedImage.vue?vue&type=script&lang=js&"
export * from "./UploadedImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadedImage.vue?vue&type=style&index=0&id=e8d98d94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d98d94",
  null
  
)

export default component.exports